import { Link } from 'react-router-dom';
import { images } from '../../assets/images';
import { ArrowRight, CheckCircle } from 'lucide-react';

const AboutPreview = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <span className="text-orange-600 font-bold uppercase tracking-wider text-sm">About Our Company</span>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mt-2 mb-6">
              Leading Manufacturer of Electrical Solutions Since 1995
            </h2>
            <p className="text-slate-600 mb-6 leading-relaxed">
              ElectroMfg Corp is dedicated to providing high-quality electrical and electronic products 
              that meet the evolving needs of modern industries. With state-of-the-art manufacturing 
              facilities and a team of expert engineers, we deliver excellence in every component.
            </p>
            
            <div className="space-y-4 mb-8">
              <div className="flex items-start">
                <CheckCircle className="text-orange-500 mt-1 mr-3 flex-shrink-0" size={20} />
                <p className="text-slate-700">ISO 9001:2015 Certified Manufacturing</p>
              </div>
              <div className="flex items-start">
                <CheckCircle className="text-orange-500 mt-1 mr-3 flex-shrink-0" size={20} />
                <p className="text-slate-700">Advanced Quality Testing Laboratory</p>
              </div>
              <div className="flex items-start">
                <CheckCircle className="text-orange-500 mt-1 mr-3 flex-shrink-0" size={20} />
                <p className="text-slate-700">Global Export Network</p>
              </div>
            </div>

            <Link 
              to="/about" 
              className="inline-flex items-center text-orange-600 font-bold hover:text-orange-700 transition-colors"
            >
              Read More About Us <ArrowRight size={20} className="ml-2" />
            </Link>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-orange-100 rounded-tl-3xl -z-10"></div>
            <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-slate-100 rounded-br-3xl -z-10"></div>
            <img 
              src={images.about} 
              alt="Factory Interior" 
              className="w-full h-[400px] object-cover rounded-lg shadow-xl"
            />
            <div className="absolute bottom-8 left-8 bg-white p-6 rounded shadow-lg max-w-xs hidden md:block">
              <p className="text-4xl font-bold text-orange-600 mb-1">9+</p>
              <p className="text-slate-600 font-medium">Years of Industrial Excellence</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPreview;
